
    import "src/shared/components/DTOFilterDateModal/index.module.scss?farm_css_modules";
    
    export default {"filterByDateTitle": `filterByDateTitle-93b7a3e6`}
    